'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMsaIdToUseForLegacyTaxes = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.useTaxServiceIfEnabled = useTaxServiceIfEnabled;
exports.calculateTaxOnCart = calculateTaxOnCart;
exports.watchCartSaga = watchCartSaga;

var _universalLogger = require('universal-logger');

var logger = _interopRequireWildcard(_universalLogger);

var _sagaTools = require('@classpass/saga-tools');

var _reduxSaga = require('redux-saga');

var _effects = require('redux-saga/effects');

var _cart = require('redux/modules/cart');

var _deep = require('helpers/deep');

var _bound = require('redux/saga/entities/bound');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(useTaxServiceIfEnabled),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(calculateTaxOnCart),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(watchCartSaga);

function useTaxServiceIfEnabled(client) {
  var taxServiceEnabled;
  return _regenerator2.default.wrap(function useTaxServiceIfEnabled$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.featureById, [client, 'use_tax_service', false]);

        case 2:
          taxServiceEnabled = _context.sent;
          _context.next = 5;
          return (0, _effects.put)((0, _cart.setTaxMethod)(taxServiceEnabled ? _cart.TAX_METHOD_TAXSERVICE : _cart.TAX_METHOD_LEGACY));

        case 5:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

var getMsaIdToUseForLegacyTaxes = exports.getMsaIdToUseForLegacyTaxes = function getMsaIdToUseForLegacyTaxes(state) {
  return (0, _deep.deepExtract)('form.purchase.values.msaId', state) || (0, _deep.deepExtract)('form.reactivation.values.msaId', state);
};

function calculateTaxOnCart(client) {
  var cart, taxTotal, msaId, rate, taxableItems, _ref2;

  return _regenerator2.default.wrap(function calculateTaxOnCart$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.call)(_reduxSaga.delay, 250);

        case 2:
          _context2.next = 4;
          return (0, _effects.select)(_cart.selectCart);

        case 4:
          cart = _context2.sent;
          taxTotal = 0;
          _context2.prev = 6;

          if (cart.postalCodeForTaxes) {
            _context2.next = 11;
            break;
          }

          taxTotal = _cart.TAX_AMOUNT_NOT_LOADED;
          _context2.next = 28;
          break;

        case 11:
          if (!(cart.taxMethod === _cart.TAX_METHOD_LEGACY)) {
            _context2.next = 21;
            break;
          }

          _context2.next = 14;
          return (0, _effects.select)(getMsaIdToUseForLegacyTaxes);

        case 14:
          msaId = _context2.sent;
          _context2.next = 17;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.taxRate, [client, msaId, cart.postalCodeForTaxes]);

        case 17:
          rate = _context2.sent;

          taxTotal = Math.round((0, _cart.legacyTaxableTotal)(cart) * (rate / 100)) / 100;
          _context2.next = 28;
          break;

        case 21:
          if (!(cart.taxMethod === _cart.TAX_METHOD_TAXSERVICE)) {
            _context2.next = 28;
            break;
          }

          taxableItems = cart.items.filter(function (item) {
            return item.sku || item.planCode;
          }).map(function (_ref) {
            var sku = _ref.sku,
                planCode = _ref.planCode;
            return sku ? { sku: sku } : { plan_id: planCode };
          });

          if (!taxableItems.length) {
            _context2.next = 28;
            break;
          }

          _context2.next = 26;
          return (0, _effects.call)(client.salesTax.estimate, {
            address: { postal_code: cart.postalCodeForTaxes },
            items: taxableItems
          });

        case 26:
          _ref2 = _context2.sent;
          taxTotal = _ref2.total_amount;

        case 28:
          _context2.next = 35;
          break;

        case 30:
          _context2.prev = 30;
          _context2.t0 = _context2['catch'](6);

          taxTotal = _cart.TAX_AMOUNT_NOT_LOADED;
          _context2.next = 35;
          return (0, _effects.call)(logger.error, _context2.t0);

        case 35:
          _context2.next = 37;
          return (0, _effects.put)((0, _cart.setTaxOnCart)(taxTotal));

        case 37:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this, [[6, 30]]);
}

function watchCartSaga(client) {
  return _regenerator2.default.wrap(function watchCartSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.fork)(_effects.takeLatest, [(0, _cart.addCartItem)().type, (0, _cart.removeCartItem)().type, (0, _cart.updateCartItem)().type, (0, _cart.setCartPostalCode)().type], calculateTaxOnCart, client);

        case 2:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}